import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

const LanguageDropdown = (props: DropdownWithoutOptionsProps<server.dto.Language, server.dto.Languages>) => {
  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={serverReference.languages}
    getLabel={l => l.localizedName}
    getValue={l => l.value}
    value={props.value}
    onChange={props.onChange}
    config={{
      isSearchable: true,
      ...props.config
    }}
  />;
};

export default LanguageDropdown;